<template>
  <section>
    <TitleBar>
      Commandes appro pass&eacute;es par l'extranet
      <template #toolbar-content>
        <TableButtonGroup
          :tableKey="tableKey"
          @rechercher="rechercher"
        ></TableButtonGroup>
      </template>
    </TitleBar>
    <b-container fluid>
      <ErrorComponent :error="error" @hide="error = null"></ErrorComponent>
      <StrapiEditoComponent></StrapiEditoComponent>
      <PaginatedTable
        :fields="fields"
        :busy="busy"
        :pageable="pageable"
        :page="page"
        @change="pageableChanged"
      >
        <template #mobile-card="{ item }">
          <LigneCommandeExtranetComponent :item="item">
          </LigneCommandeExtranetComponent>
        </template>
        <template #cell(numeroBon)="{ item }">
          <b-link
            :to="{
              name: 'commande-appro',
              params: { id: item.idCatalogue, idCommande: item.idCommande },
            }"
          >
            {{ item.numeroBon }}
          </b-link>
        </template>
        <template #cell(dateOperation)="{ item }">
          {{ isoSqlDateToFrenchDate(item.dateOperation) }}
        </template>
        <template #cell(quantiteCommandee)="{ item }">
          <MontantComponent :value="item.quantiteCommandee"></MontantComponent>
        </template>
        <template #cell(statut)="{ item }">
          <span :id="`statut-${item.idLigne}`">
            {{ item.statut.libelle }}
          </span>
          <b-tooltip
            v-if="item.statut.tooltip"
            :target="`statut-${item.idLigne}`"
            triggers="hover"
            variant="primary"
          >
            {{ item.statut.tooltip }}
          </b-tooltip>
        </template>
      </PaginatedTable>
    </b-container>
  </section>
</template>

<script>
import TitleBar from "../../components/TitleBar.vue";
import TableButtonGroup from "../../components/controls/TableButtonGroup.vue";
import ErrorComponent from "../../components/ErrorComponent.vue";
import StrapiEditoComponent from "../../components/strapi/StrapiEditoComponent.vue";
import PaginatedTable from "../../components/PaginatedTable.vue";
import LigneCommandeExtranetComponent from "../../components/cards/LigneCommandeExtranetCard.vue";
import MontantComponent from "../../components/MontantComponent.vue";
import { EtapeCommande } from "../../services/appro.service";
import ExploitationService from "../../services/exploitation.service";
import { TableKeys } from "../../store/tables.defaults";
import {
  dataFactory as tableDataFactory,
  created,
  computed as tableComputed,
  methods as tableMethods,
} from "../../services/tables.service";
import UtilsService from "../../services/utils.service";
export default {
  name: "CommandesApproView",
  components: {
    TitleBar,
    TableButtonGroup,
    ErrorComponent,
    StrapiEditoComponent,
    PaginatedTable,
    LigneCommandeExtranetComponent,
    MontantComponent,
  },
  data() {
    return {
      ...tableDataFactory(TableKeys.COMMANDES_APPRO_EXTRANET),
      error: null,
      page: null,
    };
  },
  computed: {
    ...tableComputed,
    exploitationCourante() {
      return this.$store.getters["expl/adherentCourant"];
    },
  },
  created,
  mounted() {
    this.load();
  },
  methods: {
    ...tableMethods,
    isoSqlDateToFrenchDate: UtilsService.isoSqlDateToFrenchDate,
    async load() {
      this.error = null;
      try {
        this.busy = true;
        let response = await ExploitationService.getCommandesApproExtranet(
          this.exploitationCourante.codeTiers,
          this.getSearchPayload()
        );
        response.data.content.forEach(
          (l) =>
            (l.statut = EtapeCommande.valueOf(l.statut) ?? {
              libelle: "Inconnu",
            })
        );
        this.page = response.data;
      } catch (error) {
        this.page = null;
        this.error = UtilsService.handleError(error);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
